import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

export function useBookingsRealtime(onUpdate) {
  const retryRef = useRef(null);

  useEffect(() => {
    // Unique channel name prevents conflicts when multiple tabs are open
    const channelName = `bookings-realtime-${Date.now()}`;
    let channel;

    const subscribe = () => {
      channel = supabase
        .channel(channelName)
        .on('postgres_changes', { event: '*', schema: 'public', table: 'bookings' }, onUpdate)
        .subscribe((status) => {
          if (status === 'SUBSCRIBED') {
            // Clear any pending retry on success
            if (retryRef.current) { clearTimeout(retryRef.current); retryRef.current = null; }
          }
          if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
            console.warn(`Realtime ${status} — retrying in 10s`);
            supabase.removeChannel(channel).catch(() => {});
            // Retry after 10 seconds
            retryRef.current = setTimeout(subscribe, 10_000);
          }
        });
    };

    subscribe();

    return () => {
      if (retryRef.current) { clearTimeout(retryRef.current); retryRef.current = null; }
      if (channel) supabase.removeChannel(channel).catch(() => {});
    };
  }, [onUpdate]);
}
